import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-signin',
  standalone: true,
  templateUrl: '../../assets/signin.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamSigninIcon {}
